import React from 'react'
import { History, HistoryEvent } from "./History";
import PageTransition from '../transition/PageTransition';
import {Transition, TransitionEvent} from './Transition';
import Router from './Router';

export default class BrowserRouter extends React.Component<{onChange?}> {

	history = new History();
	state = {
		path: null,
	}
	private _lastPath;
	private _currentPath;
	private _transition:Transition;
	private _hasTransition = false;

	componentDidMount()
	{
		this.history.on(HistoryEvent.CHANGE, this._historyChange);
		this._historyChange();
		if(this._transition)
		{
			this._transition.trigger.on(TransitionEvent.IN_COMPLETE, this._inComplete);
			this._transition.trigger.on(TransitionEvent.OUT_COMPLETE, this._outComplete);
			this._hasTransition = true;
		}
	}

	private _sortPaths(a:{path:string}, b:{path:string}):number
	{
		let pa = a.path.split('/').length;
		let pb = b.path.split('/').length;
		let la = a.path.length;
		let lb = b.path.length;
		if(pa > pb) return 1;
		if(pb < pa) return -1;
		if(la > lb) return 1;
		if(la < lb) return -1;
		return 0;
	}

	private _historyChange = () =>
	{
		if(this.history.path == this._currentPath) return;
		this._lastPath = this._currentPath;
		this._currentPath = this.history.path;
		if(this._hasTransition && ((!Router.routeScrollable(this._lastPath) || !Router.routeScrollable(this._currentPath)) || (Router.parentRoute(this._lastPath) != Router.parentRoute(this._currentPath))))
		{
			this.history.lockReplace();
			this._transition.transitionOut();
		}else
		{
			this.setState({path: this._currentPath});
		}
	}

	private _inComplete = () =>
	{
		
	}

	private _outComplete = () =>
	{
		if(this._hasTransition && ((!Router.routeScrollable(this._lastPath) || !Router.routeScrollable(this._currentPath)) || (Router.parentRoute(this._lastPath) != Router.parentRoute(this._currentPath))))
		{
			window.scrollTo(0, 0);
		}
		this.history.unlockReplace();
		if(this.props.onChange) this.props.onChange();
		this.setState({path: this._currentPath});
		this._transition.transitionIn();
	}

	render()
	{
		let children = [];
		if(this.state.path)
		{
			let childs:Array<any> = React.Children.toArray(this.props.children);
			let routes = [];
			childs.forEach((e) => {
				if(e.props?.path) routes.push({path: e.props.path, child: e});
			});
			routes.sort(this._sortPaths);
			routes.reverse();
			let routeChild = routes.find((e, i) => {
				return (this.state.path.indexOf(e.path) >= 0);
			});
			children = childs.map((e) => {
				if(!e.props?.path) return e;
				if(routeChild && routeChild.child == e)
				{
					return e;
				}
				return null;
			});
		}
		return (
			<React.Fragment>
				<PageTransition ref={r => this._transition = r}></PageTransition>
				{children}
			</React.Fragment>
		);
	}

}

